<template>
  <section
    class="head-pair"
    :class="{ 'head-pair__hidden': !isSoloHeadLoaded && !isViewpointsHeadLoaded }"
  >
    <div class="head-pair__left" ref="leftHead">
      <HeadFromModel
        :kind="leftHeadKind"
        :headId="headId"
        @onDataLoaded="soloHeadLoaded"
        :containerForTooltips="containerForTooltips"
        :whiteBackground="true"
      />
    </div>
    <div class="head-pair__right" ref="rightHead">
      <HeadFromModel
        :kind="rightHeadKind"
        :headId="headId"
        @onDataLoaded="viewpointsHeadLoaded"
        :containerForTooltips="containerForTooltips"
        :whiteBackground="true"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { TimelineMax } from "gsap";
import HeadFromModel from "./head-from-model.vue";
import { Kind } from "./head-models";

const props = withDefaults(
  defineProps<{
    leftHeadKind: Kind;
    rightHeadKind: Kind;
    headId: string | null;
    containerForTooltips?: string;
  }>(),
  {
    containerForTooltips: "body",
  },
);

// template refs
const leftHead = ref<HTMLElement | null>(null);
const rightHead = ref<HTMLElement | null>(null);

const isSoloHeadLoaded = ref(false);
const isViewpointsHeadLoaded = ref(false);
const hasSoloReport = ref<boolean | null>(false);
const hasViewpointsReport = ref<boolean | null>(false);

function soloHeadLoaded(hasData: boolean): void {
  isSoloHeadLoaded.value = true;
  hasSoloReport.value = hasData;
}

function viewpointsHeadLoaded(hasData: boolean): void {
  isViewpointsHeadLoaded.value = true;
  hasViewpointsReport.value = hasData;
}

function hideLeftHead(tl: TimelineMax): void {
  tl.to(leftHead.value!, 1, { autoAlpha: 0 }, 0);
}

function displayLeftHead(tl: TimelineMax): void {
  tl.to(leftHead.value!, 0, { autoAlpha: 1 }, 0);
}

function toggleBackground(tl: TimelineMax, duration: number, alphaValue: number): void {
  tl.to($(rightHead.value!).find(".head-background"), duration, { autoAlpha: alphaValue }, 0);
}

function centerRightHead(tl: TimelineMax): void {
  tl.to(rightHead.value!, 1, { marginLeft: "-100%", width: "100%", marginTop: "18%" }, 0);
  toggleBackground(tl, 1, 0);
}

function moveRightHeadBackInPlace(tl: TimelineMax): void {
  tl.to(rightHead.value!, 0, { marginLeft: 0, width: "49.5%", marginTop: "0" }, 0);
  toggleBackground(tl, 0, 1);
}

defineExpose({
  hideLeftHead,
  displayLeftHead,
  centerRightHead,
  moveRightHeadBackInPlace,
});
</script>

<style lang="less" scoped>
@import (reference) "../../styles/bootstrap/bootstrap.less";

.head-pair {
  .clearfix;

  &__hidden {
    display: none;
  }

  &__left {
    float: left;
    width: 49%;
  }

  &__right {
    float: right;
    width: 49%;
  }
}
</style>
